// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2562) return "js/app/2562.js";
	if (chunkId === 6760) return "js/app/6760.js";
	if (chunkId === 3535) return "js/app/3535.js";
	if (chunkId === 9833) return "js/app/9833.js";
	if (chunkId === 481) return "js/app/481.js";
	if (chunkId === 5782) return "js/app/5782.js";
	// return url for filenames based on template
	return undefined;
};